import React from 'react';
import { useUserPermission } from '../hooks/useUserPermission/useUserPermission';
import { PermissionKey } from '@client/api';
import { NoPackageAccessPage } from './no-access-modal';
interface PermissionProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission: PermissionKey[];
}

export const PermissionProtectedRoute: React.FC<PermissionProtectedRouteProps> = ({ children, requiredPermission }) => {
  const { hasPermission, isLoading } = useUserPermission();

  if (isLoading) return <></>;
  return hasPermission(requiredPermission) ? <>{children}</> : <NoPackageAccessPage />;
};
